<!--  -->
<template>
  <div>
    <el-dialog
      id="activity"
      title="活动参与人数"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
      center
      calss="ac-dialog"
    >
      <div class="ac-dia-form">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          size="mini"
          label-width="120px"
          label-position="left"
        >
          <el-form-item label="活动参与人数" prop="num">
            <el-input v-model.number="ruleForm.num" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogFormVisible: false,
      ruleForm: {
        num: ""
      }
    };
  },

  methods: {

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const param = {
            num: this.ruleForm.num
          };
          API.updateJoinNum(param).then(() => {
             this.dialogFormVisible = false;
            this.$emit("handlerCodeList");
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      this.$emit("handlerCodeList");
    },
 // 打开编辑视频弹窗、传递需要编辑的参数
  open(joinPersons) {
    this.dialogFormVisible = true;
    this.ruleForm.num = joinPersons;
    this.title = "修改参与人数";
  }
  },

};
</script>

<style lang='' scoped>
</style>